import { useState, type FormEvent } from 'react';
import { FolderTree } from 'lucide-react';
import { useSesion } from '../../lib/sesion.js';
import { CampoPassword } from '../../ui/CampoPassword.js';
import { ErrorApi } from '../../lib/api.js';

export function LoginPage() {
  const { entrar } = useSesion();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      await entrar(email, password);
    } catch (e) {
      setError(e instanceof ErrorApi ? e.message : 'No se pudo iniciar sesión');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 20,
        background: 'radial-gradient(900px 420px at 50% -10%, var(--green-glow), transparent 60%), var(--dark)',
      }}
    >
      <form className="card" style={{ width: 'min(380px, 100%)' }} onSubmit={enviar}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              display: 'grid',
              placeItems: 'center',
              background: 'rgba(63, 174, 106, 0.12)',
              border: '1px solid var(--border-g)',
              color: 'var(--green-light)',
            }}
          >
            <FolderTree size={19} />
          </div>
          <div>
            <h1 style={{ fontSize: '1.3rem' }}>Gestión documental</h1>
            <div className="muted" style={{ fontSize: 12 }}>
              Ingresa con tu cuenta de la organización
            </div>
          </div>
        </div>

        <div className="campo">
          <label htmlFor="email">Correo</label>
          <input
            id="email"
            className="input"
            type="email"
            autoComplete="username"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="campo">
          <label htmlFor="password">Contraseña</label>
          <CampoPassword
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && (
          <div className="error-campo" style={{ marginBottom: 12 }} role="alert">
            {error}
          </div>
        )}

        <button className="btn btn--primario" style={{ width: '100%', height: 38 }} disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
